import React from "react";
import styles from "../styles/NotFound.module.css";

function NotFound() {
  return (
    <div className={styles.gradient}>
      <h1
        style={{
          textAlign: "center",
          position: "absolute",
          top: "46%",
          left: "50%",
          color: "white",
        }}
      >
        <br></br>
        404
      </h1>
    </div>
  );
}

export default NotFound;
